import React from "react";
import { CaptionMLow } from "src/components/ui/typographic";

interface InfoItemProps {
  label: string | undefined;
  value: string | undefined;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => {
  if (!label || !value) return null;

  return (
    <div className="info-item">
      <dt className="text-secondary-2">
        <CaptionMLow>{label}</CaptionMLow>
      </dt>
      <dd
        className="text-secondary-2 text-[16px] font-bold"
        aria-describedby={`${label}-label`}
      >
        {value}
      </dd>
    </div>
  );
};

export default InfoItem;
